
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.957 12.957"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 10.257v1.081c0 .892 2.154 1.62 4.859 1.62 2.66 0 4.859-.728 4.859-1.62v-1.082a9.184 9.184 0 01-4.859 1.082A9.2 9.2 0 010 10.257zm8.1-7.018c2.66 0 4.859-.728 4.859-1.62S10.781 0 8.1 0C5.393 0 3.239.728 3.239 1.62S5.393 3.239 8.1 3.239zM0 7.6v1.308c0 .892 2.154 1.62 4.859 1.62 2.66 0 4.859-.728 4.859-1.62V7.6a8.144 8.144 0 01-4.859 1.308A8.147 8.147 0 010 7.6zm10.528.278c1.45-.283 2.429-.8 2.429-1.4V5.4a6.163 6.163 0 01-2.429.873zM4.859 4.049C2.154 4.049 0 4.955 0 6.074S2.154 8.1 4.859 8.1c2.66 0 4.859-.9 4.859-2.025S7.519 4.049 4.859 4.049zm5.547 1.422c1.521-.271 2.551-.81 2.551-1.422V2.966a8.246 8.246 0 01-4.069 1.06 2.824 2.824 0 011.518 1.445z","fill":"#21afff"}})])
          )
        }
      }
    